<template>
	<div>
		<v-row>
			<v-col cols="12" class="mt-3">
				<label-personalizado nome-campo="Título Anexo" :obrigatorio-por-padrao="true"></label-personalizado>
				<v-text-field
					id="modal-novo-anexo-campo-titulo"
					v-model="tituloAnexo"
					@change="adicionarTitulo"
					:rules="regrasTitulo"
					dense
					clearable
					type="string"
					counter="100"
					class="ma-0 py-0"
					placeholder="Informe o título"
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<label-personalizado nome-campo="Selecione o Tipo" :obrigatorio-por-padrao="true"></label-personalizado>
				<v-autocomplete
					id="modal-adicionar-anexo-tipos-documentos"
					v-model="idTipoDocumento"
					:items="tiposDocumentoModeloDataSource"
					placeholder="Selecione"
					class="ma-0 py-0"
					item-value="id"
					item-text="nome"
					dense
					clearable
					@input="adicionarTipoAnexo"
					:rules="regrasTipoDocumentoModelo"
				>
				</v-autocomplete>
			</v-col>
			<v-col cols="12">
				<label-personalizado
					nome-campo="Arquivo"
					:apresentaTooltip="true"
					:mensagemPadraoTooltip="`Você só pode adicionar 1 arquivo com as extensões: ${LABEL_EXTENSOES.join(
						', ',
					)}`"
					:obrigatorioPorPadrao="true"
				></label-personalizado>
				<campo-arquivo-novo
					id="modal-novo-anexo-campo-arquivo"
					:validate="{ required: true }"
					name="Arquivo"
					v-model="arquivoTemporario"
					:extensoes-permitidas="EXTENSOES_ARQUIVO"
					:errorUpload.sync="errorUpload"
					show-selected
					@input="tratarEventoAnexoSelecionado"
				></campo-arquivo-novo>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { actionTypes, mutationTypes } from '@/core/constants'
import constant from '@/views/mixins/constant'

export default {
	components: { LabelPersonalizado },
	mixins: [validacaoFormulario, constant],
	props: {
		infoAnexo: {
			type: Object,
			required: true,
		},
		tipoDocumento: {
			type: [String, Array],
			required: true,
			validator: function (value) {
				return (
					typeof value === 'string' ||
					(Array.isArray(value) && value.every((item) => typeof item === 'string'))
				)
			},
		},
		buscarTodosTipos: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			tituloAnexo: this.documentoComAnexo ? this.documentoComAnexo.titulo : null,
			regrasTitulo: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
			regrasTipoDocumentoModelo: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
			errorUpload: false,
			LABEL_EXTENSOES: [],
			EXTENSOES_ARQUIVO: [],
			idTipoDocumento: null,
			tiposDocumentoModeloDataSource: [],
		}
	},
	computed: {
		arquivoTemporario: {
			get() {
				return this.$store.state.campoArquivoNovo.arquivoTemporario
			},
			set(anexo) {
				this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ARQUIVO_TEMPORARIO, anexo)
			},
		},
		validacaoDocuentoEnviado: {
			get() {
				return this.$store.state.campoArquivoNovo.validacaoDocuentoEnviado
			},
			set(flag) {
				this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ARQUIVO_ENVIADO, flag)
			},
		},
		documentoComAnexo: {
			get() {
				return this.$store.state.campoArquivoNovo.documentoComAnexo
			},
			set(documento) {
				this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_DOCUMENTO_COM_ANEXOS, documento)
			},
		},
		tipoDocumentoList() {
			if (typeof this.tipoDocumento === 'string') {
				return [this.tipoDocumento]
			} else if (Array.isArray(this.tipoDocumento)) {
				return this.tipoDocumento
			} else {
				return []
			}
		},
	},
	async created() {
		this.inicializarDocumentoComAnexo()
		this.carregarListaExtensoesAceitas()
		await this.carregarTiposModeloDocumento()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ERRO_OBRIGATORIEDADE_ARQUIVO, false)
		this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ARQUIVO_ENVIADO, false)
		this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.LIMPAR_DOCUMENTO_SELECIONADO)
		this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.LIMPAR_ARQUIVO_TEMPORARIO)
		this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_FILTRO)
	},
	methods: {
		async carregarTiposModeloDocumento() {
			const { itens } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.BUSCAR_TIPOS_MODELO_DOCUMENTOS_ATIVOS,
				{
					buscarTodos: this.buscarTodosTipos,
				},
			)

			this.tiposDocumentoModeloDataSource = itens
		},
		carregarListaExtensoesAceitas() {
			this.EXTENSOES_ARQUIVO = this.getListTextConstant(this.extensoesArquivos, 'value')
			this.LABEL_EXTENSOES = this.getListTextConstant(this.extensoesArquivos, 'text')
		},
		async adicionarTitulo(titulo) {
			this.documentoComAnexo.titulo = titulo
		},
		async adicionarTipoAnexo(id) {
			this.documentoComAnexo.idTipoDocumento = id
		},
		async adicionarAnexo(anexoSelecionado) {
			try {
				this.validacaoDocuentoEnviado = false
				this.arquivoTemporario = anexoSelecionado
				const formData = this.getFormArquivoTemporario(anexoSelecionado)
				const arquivo = await this.$store.dispatch(actionTypes.ARQUIVO.ENVIAR_ARQUIVO_TEMPORARIO, formData)

				if (!this.tituloAnexo) {
					arquivo.nome = anexoSelecionado.name
					this.tituloAnexo = arquivo.nome
					this.documentoComAnexo.titulo = this.tituloAnexo
				}

				this.documentoComAnexo.idExternoAnexoTemporario = arquivo.id
				this.documentoComAnexo['idEntidade'] = this.infoAnexo.id
				this.validacaoDocuentoEnviado = true
			} catch (e) {
				this.errorUpload = true
				this.validacaoDocuentoEnviado = false
			}
		},
		async tratarEventoAnexoSelecionado(anexoSelecionado) {
			if (!anexoSelecionado) {
				this.documentoComAnexo = null
				return
			}

			await this.adicionarAnexo(anexoSelecionado)
		},
		getFormArquivoTemporario(file) {
			return {
				file: file,
				idExternoPasta: this.infoAnexo.idPastaExternaDigital,
				repositorioFlowbee: this.infoAnexo.repositorioFlowbee,
			}
		},
		inicializarDocumentoComAnexo() {
			if (!this.documentoComAnexo) {
				this.documentoComAnexo = {}
			}
		},
	},
}
</script>
